module.exports = __webpack_public_path__ + "static/media/sabrina-3.91a87195.wav";